var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbonLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 58,
    viewBox: "0 0 251 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.6979 40.249C84.1619 40.825 82.5513 41.113 80.866 41.113C79.1593 41.113 77.5914 40.8356 76.1621 40.281C74.7541 39.705 73.5381 38.905 72.5141 37.881C71.5115 36.857 70.7328 35.6411 70.1782 34.2331C69.6235 32.8038 69.3462 31.2251 69.3462 29.4972C69.3462 27.7052 69.6022 26.0626 70.1142 24.5693C70.6262 23.076 71.3728 21.796 72.3541 20.7293C73.3355 19.6627 74.5408 18.8307 75.9701 18.2334C77.3994 17.6361 79.0313 17.3374 80.866 17.3374C83.6179 17.3374 85.9326 17.9561 87.8099 19.1934C89.6871 20.4307 90.9885 22.404 91.7138 25.1133H89.5058C89.1858 24.0466 88.7485 23.14 88.1938 22.3933C87.6392 21.6253 86.9779 21.0067 86.2099 20.5373C85.4632 20.0467 84.6206 19.6947 83.6819 19.4814C82.7646 19.2467 81.7833 19.1294 80.738 19.1294C79.202 19.1294 77.8474 19.3854 76.6741 19.8974C75.5221 20.4093 74.5514 21.124 73.7621 22.0413C72.9728 22.9373 72.3755 24.0039 71.9701 25.2413C71.5861 26.4572 71.3942 27.7799 71.3942 29.2092C71.3942 30.6812 71.6075 32.0358 72.0341 33.2731C72.4608 34.5104 73.0795 35.5771 73.8901 36.473C74.7008 37.369 75.7034 38.073 76.8981 38.585C78.0927 39.0757 79.4687 39.321 81.026 39.321C81.8153 39.321 82.5939 39.2357 83.3619 39.065C84.1299 38.8943 84.8552 38.6383 85.5379 38.297C86.2205 37.9344 86.8392 37.4864 87.3939 36.953C87.9485 36.3984 88.4072 35.7477 88.7698 35.0011C88.8765 34.7664 88.9725 34.5317 89.0578 34.2971C89.1645 34.0624 89.2712 33.8278 89.3778 33.5931H91.6818C91.1271 35.1931 90.3911 36.5584 89.4738 37.689C88.5565 38.8197 87.2979 39.673 85.6979 40.249Z",
    fill: "url(#paint0_linear_1008_3443)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.997 40.633L116.181 33.0811H106.006L103.158 40.633H100.95L109.397 17.8174H112.789L121.237 40.633H118.997ZM106.549 31.4811H115.765L111.029 19.2894L106.549 31.4811Z",
    fill: "url(#paint1_linear_1008_3443)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.285 40.633L142.645 31.7691H134.037V40.633H131.893V17.8174H142.293C143.295 17.8174 144.255 17.9881 145.173 18.3294C146.09 18.6707 146.911 19.1507 147.637 19.7694C148.362 20.3667 148.938 21.1027 149.365 21.9773C149.791 22.8306 150.005 23.7693 150.005 24.7933C150.005 25.8599 149.738 26.8732 149.205 27.8332C148.671 28.7932 147.989 29.5825 147.157 30.2012C147.029 30.2865 146.869 30.3932 146.677 30.5212C146.506 30.6278 146.325 30.7345 146.133 30.8412C145.941 30.9478 145.759 31.0438 145.589 31.1291C145.418 31.2145 145.279 31.2571 145.173 31.2571L144.821 31.2891L149.781 40.633H147.285ZM134.037 29.9772H142.293C143.445 29.9772 144.501 29.6572 145.461 29.0172C146.421 28.3559 147.114 27.4812 147.541 26.3932C147.605 26.2226 147.658 26.0412 147.701 25.8492C147.765 25.6572 147.797 25.4439 147.797 25.2093C147.797 24.3986 147.658 23.652 147.381 22.9693C147.125 22.2866 146.751 21.7 146.261 21.2093C145.77 20.7187 145.183 20.3347 144.501 20.0574C143.839 19.7587 143.103 19.6094 142.293 19.6094H134.037V29.9772Z",
    fill: "url(#paint2_linear_1008_3443)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.872 17.8174H170.184C171.123 17.8174 172.019 17.9561 172.872 18.2334C173.726 18.4894 174.472 18.884 175.112 19.4174C175.752 19.9294 176.254 20.5693 176.616 21.3373C177 22.1053 177.192 22.9906 177.192 23.9933C177.192 24.6546 177.011 25.2839 176.648 25.8812C176.307 26.4786 175.902 27.0119 175.432 27.4812C175.304 27.6092 175.176 27.7372 175.048 27.8652C174.92 27.9719 174.792 28.0892 174.664 28.2172L174.472 28.4092L174.888 28.6652C175.87 29.2412 176.691 29.9985 177.352 30.9371C178.014 31.8545 178.344 32.8998 178.344 34.0731C178.344 34.8411 178.216 35.5771 177.96 36.281C177.619 37.1557 177.171 37.881 176.616 38.457C176.062 39.0117 175.422 39.449 174.696 39.769C173.992 40.089 173.224 40.313 172.392 40.441C171.56 40.569 170.707 40.633 169.832 40.633H160.872V17.8174ZM163.048 27.7692H170.408C170.984 27.7692 171.539 27.6625 172.072 27.4492C172.627 27.2359 173.107 26.9372 173.512 26.5532C173.939 26.1692 174.27 25.7212 174.504 25.2093C174.76 24.6759 174.888 24.1106 174.888 23.5133C174.888 22.8733 174.76 22.3186 174.504 21.8493C174.248 21.3587 173.907 20.9427 173.48 20.6013C173.075 20.26 172.595 20.004 172.04 19.8334C171.507 19.6627 170.963 19.5774 170.408 19.5774H163.048V27.7692ZM163.048 38.841H170.888C171.635 38.841 172.382 38.7237 173.128 38.489C173.534 38.361 173.918 38.1583 174.28 37.881C174.643 37.6037 174.963 37.273 175.24 36.889C175.518 36.505 175.731 36.0997 175.88 35.6731C176.051 35.2251 176.136 34.7877 176.136 34.3611C176.136 33.6571 175.998 33.0064 175.72 32.4091C175.443 31.8118 175.07 31.2998 174.6 30.8732C174.152 30.4465 173.619 30.1158 173 29.8812C172.382 29.6465 171.731 29.5292 171.048 29.5292H163.048V38.841Z",
    fill: "url(#paint3_linear_1008_3443)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.358 24.6333C189.742 23.4173 190.275 22.3613 190.958 21.4653C191.641 20.548 192.441 19.7907 193.358 19.1934C194.275 18.5747 195.289 18.1161 196.398 17.8174C197.528 17.5187 198.712 17.3694 199.95 17.3694C201.784 17.3694 203.427 17.6361 204.878 18.1694C206.35 18.7027 207.587 19.4814 208.59 20.5053C209.592 21.5293 210.36 22.7773 210.894 24.2493C211.427 25.6999 211.694 27.3532 211.694 29.2092C211.694 31.0011 211.427 32.6331 210.894 34.1051C210.382 35.5771 209.624 36.8357 208.622 37.881C207.64 38.905 206.435 39.705 205.006 40.281C203.598 40.8356 201.987 41.113 200.174 41.113C198.318 41.113 196.675 40.8143 195.246 40.217C193.817 39.5983 192.611 38.745 191.63 37.657C190.67 36.569 189.934 35.2677 189.422 33.7531C188.91 32.2385 188.654 30.5852 188.654 28.7932C188.654 28.0892 188.707 27.3959 188.814 26.7132C188.942 26.0092 189.123 25.3159 189.358 24.6333ZM200.334 19.1294C199.416 19.1294 198.467 19.236 197.486 19.4494C196.526 19.6414 195.651 19.9934 194.862 20.5053C194.158 20.9533 193.539 21.4973 193.006 22.1373C192.494 22.756 192.057 23.4386 191.694 24.1853C191.353 24.9106 191.097 25.6679 190.926 26.4572C190.755 27.2466 190.67 28.0252 190.67 28.7932C190.67 30.2012 190.873 31.5451 191.278 32.8251C191.683 34.1051 192.281 35.2251 193.07 36.185C193.859 37.145 194.841 37.913 196.014 38.489C197.187 39.0437 198.531 39.321 200.046 39.321C201.07 39.321 202.04 39.2037 202.958 38.969C203.875 38.7343 204.707 38.3717 205.454 37.881C206.222 37.3904 206.883 36.7717 207.438 36.0251C208.014 35.2784 208.462 34.3931 208.782 33.3691C209.016 32.6225 209.166 31.8651 209.23 31.0971C209.294 30.3292 209.326 29.5718 209.326 28.8252C209.326 27.4172 209.123 26.1266 208.718 24.9533C208.334 23.7586 207.758 22.7346 206.99 21.8813C206.243 21.0067 205.304 20.3347 204.174 19.8654C203.064 19.3747 201.784 19.1294 200.334 19.1294Z",
    fill: "url(#paint4_linear_1008_3443)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.777 17.8174V40.633H239.793L225.777 21.2093V40.633H223.601V17.8174H225.617L239.601 37.241V17.8174H241.777Z",
    fill: "url(#paint5_linear_1008_3443)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06934 33.6387C8.27956 33.6446 8.49052 33.6475 8.70216 33.6475C13.0545 33.6475 17.1151 32.3981 20.5447 30.2383C21.9486 37.4646 28.3113 42.92 35.9481 42.92C42.1983 42.92 47.595 39.2658 50.1184 33.9774C50.314 33.874 50.5072 33.7666 50.6978 33.6552C47.94 42.8123 39.442 49.482 29.3861 49.482C19.3241 49.482 10.8218 42.8042 8.06934 33.6387Z",
    fill: "url(#paint6_radial_1008_3443)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06934 33.6387C8.27956 33.6446 8.49052 33.6475 8.70216 33.6475C13.0545 33.6475 17.1151 32.3981 20.5447 30.2383C21.9486 37.4646 28.3113 42.92 35.9481 42.92C42.1983 42.92 47.595 39.2658 50.1184 33.9774C50.314 33.874 50.5072 33.7666 50.6978 33.6552C47.94 42.8123 39.442 49.482 29.3861 49.482C19.3241 49.482 10.8218 42.8042 8.06934 33.6387Z",
    fill: "#04171E",
    fillOpacity: 0.88
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17627 33.9834C8.35114 33.9874 8.52651 33.9895 8.70236 33.9895C13.081 33.9895 17.1643 32.7249 20.6069 30.541C22.1277 37.6162 28.4187 42.9195 35.9483 42.9195C42.1985 42.9195 47.5952 39.2654 50.1186 33.9769C50.3142 33.8735 50.5074 33.7661 50.698 33.6548C47.9402 42.8118 39.4421 49.4816 29.3862 49.4816C19.451 49.4816 11.0365 42.9709 8.17627 33.9834Z",
    fill: "url(#paint7_radial_1008_3443)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17627 33.9834C8.35114 33.9874 8.52651 33.9895 8.70236 33.9895C13.081 33.9895 17.1643 32.7249 20.6069 30.541C22.1277 37.6162 28.4187 42.9195 35.9483 42.9195C42.1985 42.9195 47.5952 39.2654 50.1186 33.9769C50.3142 33.8735 50.5074 33.7661 50.698 33.6548C47.9402 42.8118 39.4421 49.4816 29.3862 49.4816C19.451 49.4816 11.0365 42.9709 8.17627 33.9834Z",
    fill: "#04171E",
    fillOpacity: 0.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9146 42.4144C36.7505 45.046 32.6829 46.6287 28.2458 46.6287C19.9631 46.6287 12.9685 41.114 10.7334 33.5561C14.3166 33.2319 17.6547 32.0583 20.5447 30.2383C21.9487 37.4646 28.3113 42.92 35.9482 42.92C37.3184 42.92 38.6476 42.7443 39.9146 42.4144Z",
    fill: "url(#paint8_linear_1008_3443)",
    fillOpacity: 0.64
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6467 27.2279C47.6467 37.3124 39.4716 45.4875 29.3871 45.4875C19.3026 45.4875 11.1274 37.3124 11.1274 27.2279C11.1274 17.1434 19.3026 8.96826 29.3871 8.96826C39.4716 8.96826 47.6467 17.1434 47.6467 27.2279Z",
    fill: "url(#paint9_radial_1008_3443)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4325 23.7993C46.4325 30.8899 40.6844 36.6381 33.5937 36.6381C26.503 36.6381 20.7549 30.8899 20.7549 23.7993C20.7549 16.7086 26.503 10.9604 33.5937 10.9604C40.6844 10.9604 46.4325 16.7086 46.4325 23.7993Z",
    fill: "url(#paint10_radial_1008_3443)",
    fillOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5842 10.9835C30.2978 10.9682 30.0094 10.9604 29.7192 10.9604C26.9876 10.9604 24.4165 11.6477 22.1694 12.8588C23.3712 12.594 24.6199 12.4544 25.9012 12.4544C27.2073 12.4544 28.4794 12.5994 29.7025 12.8743L30.5842 10.9835Z",
    fill: "url(#paint11_linear_1008_3443)",
    fillOpacity: 0.64
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6406 13.4314C38.3537 15.797 43.1649 22.1957 43.1649 29.7181C43.1649 32.8107 42.3517 35.7134 40.9275 38.224C43.8465 35.3356 45.6548 31.327 45.6548 26.8961C45.6548 19.1019 40.0592 12.6146 32.666 11.2324L31.6406 13.4314Z",
    fill: "url(#paint12_linear_1008_3443)",
    fillOpacity: 0.64
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1451 42.6644C36.3224 44.4525 32.9756 45.4877 29.387 45.4877C23.6998 45.4877 18.6198 42.8876 15.271 38.8113C16.1942 38.9805 17.1456 39.0689 18.1176 39.0689C25.1759 39.0689 31.1457 34.4088 33.1182 27.9975C33.769 28.0548 34.4278 28.084 35.0935 28.084C39.6535 28.084 43.8933 26.7125 47.4226 24.3594C47.5701 25.2939 47.6467 26.2521 47.6467 27.2281C47.6467 27.8339 47.6172 28.4329 47.5595 29.0235C46.5338 34.563 43.4564 39.3825 39.1451 42.6644Z",
    fill: "url(#paint13_linear_1008_3443)",
    fillOpacity: 0.64
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0752 33.6548C10.8327 42.8122 19.331 49.4823 29.3872 49.4823C41.6303 49.4823 51.5643 39.5955 51.6406 27.3703C50.4192 27.3626 49.2212 27.2565 48.054 27.0596C45.311 28.2685 42.2778 28.9397 39.0877 28.9397C37.9815 28.9397 36.8942 28.859 35.8313 28.7031C33.861 35.1181 27.8894 39.7816 20.8285 39.7816C15.9048 39.7816 11.5107 37.5139 8.63374 33.9659C8.44524 33.8659 8.25903 33.7621 8.0752 33.6548Z",
    fill: "url(#paint14_linear_1008_3443)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6403 27.3896C48.3672 29.2829 44.5671 30.3665 40.5139 30.3665C39.7414 30.3665 38.9782 30.3271 38.226 30.2503C36.8173 37.4706 30.4575 42.92 22.8249 42.92C16.5747 42.92 11.178 39.2659 8.65461 33.9774C8.45899 33.874 8.26581 33.7666 8.0752 33.6553C10.8329 42.8123 19.331 49.482 29.3869 49.482C41.6236 49.482 51.5535 39.6058 51.6403 27.3896Z",
    fill: "url(#paint15_radial_1008_3443)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0179 28.2407C48.6774 28.8748 47.2635 29.3788 45.7923 29.7367C45.6016 31.3617 45.2348 32.9914 44.6803 34.6017C43.3287 38.527 41.028 41.8558 38.123 44.42C43.0903 42.0296 47.1374 37.7321 49.0739 32.1082C49.5149 30.8275 49.8272 29.5337 50.0179 28.2407Z",
    fill: "url(#paint16_linear_1008_3443)",
    fillOpacity: 0.64
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8216 28.7414C35.8468 28.7078 35.8937 28.7015 35.9263 28.7274C36.6692 29.3167 37.472 29.8365 38.3325 30.2774C38.3694 30.2964 38.3844 30.3425 38.3661 30.3806C38.3477 30.4186 38.3029 30.4341 38.266 30.4152C37.3967 29.9697 36.5857 29.4446 35.8353 28.8493C35.8026 28.8234 35.7965 28.7751 35.8216 28.7414Z",
    fill: "url(#paint17_linear_1008_3443)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1008_3443",
    x1: 69.3462,
    y1: 29.2874,
    x2: 200.536,
    y2: 114.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1008_3443",
    x1: 69.3462,
    y1: 29.2874,
    x2: 200.536,
    y2: 114.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1008_3443",
    x1: 69.3462,
    y1: 29.2874,
    x2: 200.536,
    y2: 114.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1008_3443",
    x1: 69.3462,
    y1: 29.2874,
    x2: 200.536,
    y2: 114.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1008_3443",
    x1: 69.3462,
    y1: 29.2874,
    x2: 200.536,
    y2: 114.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1008_3443",
    x1: 69.3462,
    y1: 29.2874,
    x2: 200.536,
    y2: 114.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1008_3443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.6978 44.7815) rotate(179.948) scale(161.582 469.497)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#24537E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAFFF4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1008_3443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.698 44.7811) rotate(179.948) scale(161.582 469.497)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#24537E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAFFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1008_3443",
    x1: 39.3688,
    y1: 49.7049,
    x2: 32.0274,
    y2: 11.5183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1008_3443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0243 41.5036) rotate(-57.5402) scale(32.1658 466.099)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1008_3443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3624 10.9655) rotate(144.267) scale(31.6325 31.408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216485,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906332,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1008_3443",
    x1: 40.9419,
    y1: 18.0981,
    x2: 22.1117,
    y2: 26.3007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732381,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1008_3443",
    x1: 40.9419,
    y1: 18.0981,
    x2: 22.1117,
    y2: 26.3007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732381,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1008_3443",
    x1: 75.8941,
    y1: -20.9191,
    x2: -1.12022,
    y2: 43.2445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1008_3443",
    x1: 43.5096,
    y1: 30.1523,
    x2: 14.6222,
    y2: 40.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E6585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1008_3443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9168 47.072) rotate(-38.5632) scale(26.3382 410.794)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1008_3443",
    x1: 50.0715,
    y1: 28.2262,
    x2: 38.9623,
    y2: 45.0652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1008_3443",
    x1: 38.3589,
    y1: 30.3422,
    x2: 34.7474,
    y2: 28.1096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonLogo);
export default __webpack_public_path__ + "static/media/carbon_logo.65c5cbf1.svg";
export { ForwardRef as ReactComponent };